import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { textFieldSx } from './formStyles';

export type FormTextFieldProps = TextFieldProps;

export const FormTextField: React.FC<FormTextFieldProps> = ({
  variant = 'outlined',
  fullWidth = true,
  size = 'small',
  sx,
  ...props
}) => (
  <TextField
    variant={variant}
    fullWidth={fullWidth}
    size={size}
    sx={[textFieldSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    {...props}
  />
);
